import { Provider } from "react-redux";
import store from "./redux/store";
import Router from "./router/router.index";
import ToastContainer from "mobin-toast";
import { useEffect } from "react";
import { ENVIRONMENT } from "./environment";
import ReactTooltip from "react-tooltip";
import { isTouchScreen } from "./scripts/helpers";

// const config = {
//     url: "https://abrehamrahi.ir/unleash/",
//     clientKey: "xWa4t6R7xIY7JIkRZzAoYjjRMIi6Sstf",
//     disableRefresh: true,
//     appName: "abrehamrahi",
//     environment: "production"
// }; // Unleash config

function App() {
    useEffect(() => {
        document.title = ENVIRONMENT.brandName;
        let logo = "/drive/hamrahi.svg";

        const link: any = document.querySelector("link[rel~='icon']");
        link.href = logo;

        // Add title
        const title: any = document.createElement("title");
        link.innerHTML = ENVIRONMENT.brandName;
        document.head.appendChild(title);

        // Add meat description
        const description: any = document.createElement("meta");
        description.name = "description";
        description.content = ENVIRONMENT.metaDescription;
        document.head.appendChild(description);

        // Add google Analytics
        const ga_main = document.createElement("script");
        ga_main.src = "https://www.googletagmanager.com/gtag/js?id=" + ENVIRONMENT.googleAnalyticsId;
        ga_main.async = true; // Set the 'async' attribute to true
        document.head.appendChild(ga_main);
        const ga_code = document.createElement("script");
        ga_code.textContent =
            `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);} gtag('js', new Date());gtag('config', '` +
            ENVIRONMENT.googleAnalyticsId +
            `');`;
        document.head.appendChild(ga_code);

        // Add hotJar
        const hotJar = document.createElement("script");
        hotJar.textContent =
            "" +
            "\t\t\t(function (h, o, t, j, a, r) {\n" +
            "\t\t\t\th.hj =\n" +
            "\t\t\t\t\th.hj ||\n" +
            "\t\t\t\t\tfunction () {\n" +
            "\t\t\t\t\t\t(h.hj.q = h.hj.q || []).push(arguments);\n" +
            "\t\t\t\t\t};\n" +
            "\t\t\t\th._hjSettings = { hjid: " +
            ENVIRONMENT.hotJarId.toString() +
            ", hjsv: 6 };\n" +
            "\t\t\t\ta = o.getElementsByTagName('head')[0];\n" +
            "\t\t\t\tr = o.createElement('script');\n" +
            "\t\t\t\tr.async = 1;\n" +
            "\t\t\t\tr.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;\n" +
            "\t\t\t\ta.appendChild(r);\n" +
            "\t\t\t})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');";
        document.head.appendChild(hotJar);
    }, []);

    return (
        <Provider store={store}>
            {!isTouchScreen() && <ReactTooltip effect="solid" />}
            <ToastContainer position="bottom-right" autoClose={3000} theme="light" />
            <Router />
        </Provider>
    );
}

export default App;
